import { Injectable } from "@angular/core";
import { API_METHODS, API_URL } from "common/constants/sm-constants";
import { environment } from "src/environments/environment";
import { BranchesModel } from "common/models/page-models/Branches/branches-data-model";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { FormDataService } from "../../base-data-services/form-data.service";


@Injectable({
    providedIn: 'root'
})
export class BranchesFormDataService extends FormDataService<BranchesModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.addBranch, http, ss);
    }

    override getEditUrlAndMethod(id) {
        const edit = {
            url: environment.apiUrl + API_URL.getBranchesById,
            method: API_METHODS.post
        }
        return edit;
    }

    override getUpdatePayload(data) {
        let payload;
        payload = {
            id: data.id,
        };
        return payload;
    }


    createInstance(): BranchesModel {
        return new BranchesModel();
    }

    // override modifyAPIResponse(response: any) {
    //     return response['detail'][0];
    // }

    override getUpdateUrl() {
        return API_URL.updateBranch;
    }




    //     override getDetailCustomUrl() {
    //         const getUrl = environment.apiUrl + API_URL.getBranchesGrid;
    //         return getUrl;
    //     }

    //    override async getUpdateData(id):Promise<any>{
    //         return await new Promise((resolve, reject) => {
    //             const url = this.getDetailCustomUrl();
    //             const get_id = { id: id };
    //             const formData = this.convertFormData(get_id);
    //             this.http
    //                 .postData(url,formData)
    //                 .then(res => {
    //                     const modifiedResponse = this.modifyAPIResponse(res);
    //                     resolve(modifiedResponse);
    //                 })
    //                 .catch(err => {
    //                     reject(err);
    //                 });
    //         });
    //     }

    // override async postData(data, url='',token: any = null): Promise<any> {
    //     return await new Promise((resolve, reject) => {

    //         const url = environment.apiUrl + API_URL.getBranchCategoryList;

    //         this.apiService
    //             .postData(url, this.convertFormData(data), token)

    //             .then(res => {

    //                     resolve(res);
    //             })
    //             .catch(err => {
    //                 reject(err);
    //             });
    //     });

    // }


    //     override modifyAPIResponse(response: any) {
    //         const dataModel = this.createInstance();
    //         const receivedData=JSON.parse(response)
    //         dataModel.department_name = receivedData?.detail[0]?.department_name;
    //         dataModel.branchCategoryId=receivedData?.detail[0]?.branchCategoryId;
    //         dataModel.id=receivedData?.detail[0]?.id;
    //         return dataModel;
    //     }
    // }
}

export { FormDataService };
